
import ClickOutside from "vue-click-outside";

export default {
  directives: { ClickOutside },

  props: {
    hideTrigger: { type: Boolean, default: false },
    closeOnScroll: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
  },

  data: () => ({
    open: false,
    id: Math.random().toString(36).substr(2, 11),
  }),

  computed: {
    isOpen() {
      return this.visible || this.open;
    },
  },

  watch: {
    visible: {
      handler(val) {
        if (val) this.openModal();
        else this.open = false;
      },
      immediate: true,
    },
  },

  mounted() {
    this.$root.$on("info-modal:open", this.handleOtherModal);
  },

  beforeDestroy() {
    this.$root.$off("info-modal:open", this.handleOtherModal);
  },

  methods: {
    toggle() {
      this.isOpen ? this.close() : this.openModal();
    },
    openModal() {
      this.$root.$emit("info-modal:open", this.id);
      this.open = true;
      this.$emit("update:visible", true);
    },
    handleOtherModal(openedId) {
      if (openedId !== this.id && this.isOpen) this.close();
    },
    handleOutsideClick() {
      if (this.isOpen) this.close();
    },
    close() {
      this.open = false;
      this.$emit("update:visible", false);
      this.$emit("close-modal");
    },
    catchScroll() {
      if (this.isOpen && this.closeOnScroll) this.close();
    },
  },
};
